import { AdviceIntroDesc, AdviceMessageStyle } from "./styled";

import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { useProductTexts } from "Store/texts/hooks";
import { isDefined } from "Utils/functions";
import React from "react";
import { ChildAdviceIntroMessage } from "../../ProductPrice/AdviceMessages/AdviceIntro/ChildAdviceIntroMessage";
import { Description } from "../../adviceStyled";
import { SortedNeed } from "../utils";
import { generateIntroMessage } from "./adviceIntroMessagesUtils";

interface Props {
  sortedNeeds: SortedNeed[];
  isCollectiveAdvice?: boolean;
}

export const AdviceIntroMessages = ({
  sortedNeeds,
  isCollectiveAdvice = false,
}: Props): React.ReactElement => {
  const isAdvisor = useIsAdvisorSelector();
  const [{ formText }, lang] = useProductTexts(
    getFMSProductName(ProductBackendName.ADVICE),
  );
  const messages = sortedNeeds.map((sortedNeed) =>
    generateIntroMessage(
      isAdvisor,
      isCollectiveAdvice,
      sortedNeed,
      formText.advice,
      lang,
    ),
  );

  return (
    <AdviceMessageStyle className="AdviceIntroMessages">
      {messages
        .filter((message) => message.insurances.length > 0)
        .map((message) => {
          if (!isDefined(message.title)) {
            return message.insurances.map((insurance) => (
              <AdviceMessageStyle key={`AdviceIntroMessages_${insurance.name}`}>
                <AdviceIntroDesc
                  fw={600}
                  size="16px"
                  className="AdviceMessageTitle"
                >
                  {insurance.name}
                </AdviceIntroDesc>
                {isDefined(insurance.reason) && (
                  <AdviceIntroDesc
                    fw={400}
                    size="16px"
                    style={{ marginTop: 8, marginBottom: 8 }}
                    className="AdviceMessageText"
                  >
                    {insurance.reason}
                  </AdviceIntroDesc>
                )}
                {isDefined(insurance.warning) && (
                  <AdviceIntroDesc
                    fw={400}
                    size="16px"
                    style={{ marginTop: 8, marginBottom: 8 }}
                    className="AdviceMessageWarn"
                  >
                    {insurance.warning}
                  </AdviceIntroDesc>
                )}
              </AdviceMessageStyle>
            ));
          }

          return (
            <AdviceMessageStyle key={`AdviceIntroMessages_${message.title}`}>
              <Description
                fw={600}
                size="16px"
                className="AdviceMessageTitle"
                style={{ marginBottom: 0 }}
              >
                {message.title}
              </Description>
              <ol style={{ marginLeft: 24, marginTop: 6 }}>
                {message.insurances.map((insurance) => (
                  <li
                    key={`AdviceIntroMessages_${insurance.name}`}
                    style={{ marginBottom: "4px" }}
                  >
                    <AdviceIntroDesc
                      fw={600}
                      size="16px"
                      className="AdviceMessageTitle"
                    >
                      {insurance.name}
                    </AdviceIntroDesc>
                    {isDefined(insurance.reason) && (
                      <AdviceIntroDesc
                        fw={400}
                        size="16px"
                        className="AdviceMessageText"
                      >
                        {insurance.reason}
                      </AdviceIntroDesc>
                    )}
                    {isDefined(insurance.warning) && (
                      <AdviceIntroDesc
                        fw={400}
                        size="16px"
                        className="AdviceMessageWarn"
                      >
                        {insurance.warning}
                      </AdviceIntroDesc>
                    )}
                  </li>
                ))}
              </ol>
            </AdviceMessageStyle>
          );
        })}
      <ChildAdviceIntroMessage
        adviceTexts={formText.advice}
        lang={lang}
        isCollectiveAdvice={isCollectiveAdvice}
      />
    </AdviceMessageStyle>
  );
};
